/* Tiroir panier Elite — Panier/tiroir/elite-tiroir.js → assets/elite-tiroir.js
   Chargé par snippets/cart-drawer.liquid quand « Style Elite » est coché. Le thème (Shrine) redessine le contenu du
   tiroir par innerHTML à chaque changement (renderContents / updateQuantity) : tout passe par un MutationObserver et
   reste idempotent (repères data-et-vu).
   - barre « livraison offerte » animée depuis la valeur précédente, fête quand le palier est franchi ;
   - offre 3 achetés = 1 offert : fête quand un article offert s'ajoute ;
   - suggestions chargées à la demande (sections/elite-tiroir-suggestions.liquid), mises en cache par contenu du
     panier (sessionStorage, 30 min), ajout en un clic sans quitter le tiroir ;
   - photos « Patch perso » recopiées dans __mws_apo_cta avant le paiement (même correctif que Panier/panier-refonte.js,
     qui ne tourne que sur la page panier : depuis le tiroir, on peut payer sans y passer). */
(function () {
  'use strict';
  if (window.eliteTiroir) return;
  window.eliteTiroir = true;

  var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'elite-tiroir-suggestions';
  var CLE_ETAT = 'etTiroirEtat';
  var CLE_SUGG = 'etTiroirSugg';
  var DUREE_CACHE = 30 * 60 * 1000;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pagePanier = /\/cart\/?$/.test(location.pathname);

  function lire(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ecrire(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function tiroir() { return document.querySelector('cart-drawer.elite-tiroir'); }
  function ouvert() { var d = tiroir(); return !!(d && d.classList.contains('active')); }
  function texte(cle, defaut) {
    var p = document.querySelector('cart-drawer.elite-tiroir .et-pied');
    return (p && p.getAttribute('data-t-' + cle)) || defaut;
  }

  var etat = lire(CLE_ETAT) || {};
  function garderEtat() { ecrire(CLE_ETAT, etat); }

  /* ── Fêtes (palier atteint) : jouées tiroir ouvert, sinon à l'ouverture ── */
  var fetesEnAttente = [];
  function feter(selBloc, selOrigine) {
    if (reduit) return;
    if (!ouvert()) { fetesEnAttente.push([selBloc, selOrigine]); return; }
    setTimeout(function () {
      var d = tiroir();
      var bloc = d && d.querySelector(selBloc);
      if (!bloc) return;
      bloc.classList.remove('et-fete');
      void bloc.offsetWidth;
      bloc.classList.add('et-fete');
      setTimeout(function () { bloc.classList.remove('et-fete'); }, 2200);
      var o = bloc.querySelector(selOrigine) || bloc;
      confettis(o.getBoundingClientRect());
    }, 380);
  }
  function confettis(r) {
    var d = tiroir();
    if (!d) return;
    var box = document.createElement('div');
    box.className = 'et-confettis';
    box.style.left = (r.left + r.width / 2) + 'px';
    box.style.top = (r.top + r.height / 2) + 'px';
    var couleurs = ['#e0001b', '#efc200', '#0e0e0e', '#e0001b', '#efc200'];
    for (var i = 0; i < 26; i++) {
      var c = document.createElement('i');
      var angle = Math.random() * Math.PI * 2;
      var dist = 50 + Math.random() * 90;
      c.style.background = couleurs[i % couleurs.length];
      c.style.setProperty('--x', Math.round(Math.cos(angle) * dist) + 'px');
      c.style.setProperty('--y', Math.round(Math.sin(angle) * dist + 40) + 'px');
      c.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
      c.style.animationDelay = Math.round(Math.random() * 90) + 'ms';
      box.appendChild(c);
    }
    d.appendChild(box);
    setTimeout(function () { box.remove(); }, 1500);
  }

  /* ── Barre « livraison offerte » ── */
  function livraison(d, initial) {
    var liv = d.querySelector('.et-liv:not([data-et-vu])');
    if (!liv) return;
    liv.setAttribute('data-et-vu', '');
    var pct = parseInt(liv.getAttribute('data-et-pct'), 10) || 0;
    var ok = liv.getAttribute('data-et-ok') === '1';
    var rempli = liv.querySelector('.et-liv__rempli');
    if (rempli && typeof etat.pct === 'number' && etat.pct !== pct && !reduit) {
      // le thème vient de redessiner la barre à sa valeur finale : on repart de l'ancienne pour la voir avancer
      rempli.style.transition = 'none';
      rempli.style.width = etat.pct + '%';
      void rempli.offsetWidth;
      rempli.style.transition = '';
      rempli.style.width = pct + '%';
    }
    if (!initial && ok && etat.ok === false) feter('.et-liv', '.et-liv__but');
    etat.pct = pct;
    etat.ok = ok;
  }

  /* ── Offre 3 achetés = 1 offert ── */
  function promo(d, initial) {
    var p = d.querySelector('.et-promo:not([data-et-vu])');
    if (!p) return;
    p.setAttribute('data-et-vu', '');
    var offerts = parseInt(p.getAttribute('data-et-offerts'), 10) || 0;
    if (!initial && typeof etat.offerts === 'number' && offerts > etat.offerts) feter('.et-promo', '.et-point--cadeau');
    etat.offerts = offerts;
  }

  /* ── Lignes : étiquettes d'options ──
     « Patchs supplémentaires » (ligne technique d'APO) masqué ; les photos envoyées (« Patch perso n », un lien brut)
     sont masquées aussi et deviennent, dans la liste des patchs, un lien « Mon patch n » vers la photo. */
  function numeroPerso(v) {
    var r = /^Patch personnalisé(?: (\d+))? \(photo jointe\)$/.exec(String(v || '').trim());
    return r ? (r[1] ? parseInt(r[1], 10) : 1) : 0;
  }
  function lignes(d) {
    Array.prototype.forEach.call(d.querySelectorAll('.cart-drawer-item:not([data-et-vu])'), function (item) {
      item.setAttribute('data-et-vu', '');
      var urls = {}, optPatchs = null;
      Array.prototype.forEach.call(item.querySelectorAll('dl .product-option'), function (o) {
        var dt = o.querySelector('dt');
        var k = dt ? dt.textContent.replace(/:\s*$/, '').trim() : '';
        var n = numeroPropriete(k);
        if (n) {
          var a = o.querySelector('a[href]');
          if (a) urls[n] = a.getAttribute('href');
          o.classList.add('et-cache');
        } else if (/patch|parche/i.test(k) && /suppl|extra|adicional|zus[aä]tz|aggiunt|ytterlig|adiciona/i.test(k)) {
          o.classList.add('et-cache');
        } else if (/patch|parche/i.test(k)) optPatchs = o;
      });
      var dd = optPatchs && optPatchs.querySelector('dd');
      var valeurs = dd ? dd.textContent.split('|').map(function (v) { return v.trim(); }).filter(Boolean) : [];
      var persos = valeurs.filter(numeroPerso);
      if (persos.length) {
        dd.textContent = '';
        valeurs.forEach(function (v, i) {
          if (i) dd.appendChild(document.createTextNode(', '));
          var n = numeroPerso(v);
          if (!n) { dd.appendChild(document.createTextNode(v)); return; }
          var nom = texte('perso', 'Mon patch') + (persos.length > 1 ? ' ' + (persos.indexOf(v) + 1) : '');
          var el = document.createElement(urls[n] ? 'a' : 'span');
          el.textContent = nom;
          if (urls[n]) { el.href = urls[n]; el.target = '_blank'; el.rel = 'noopener'; }
          dd.appendChild(el);
        });
        optPatchs.classList.add('et-perso');
      }
      // ligne gratuite (3 achetés = 1 offert) : « Offert » vient d'un réglage du bloc articles du thème, en français
      var offert = texte('offert', 'Offert');
      if (offert !== 'Offert') Array.prototype.forEach.call(item.querySelectorAll('.cart-item__totals .regular-price'), function (p) {
        if (p.textContent.trim() === 'Offert') p.textContent = offert;
      });
      repli(item);
      invitationPerso(item);
    });
  }

  /* ── Personnalisation repliée (demande du user, 21/10/2026) : la taille reste visible, le flocage (propriétés de
     ligne, classe et-prop posée par snippets/cart-drawer.liquid) s'affiche sur demande. L'état ouvert est gardé par
     ligne quand le thème redessine le tiroir. ── */
  var persoOuvertes = {};
  function regler(item, b, o) {
    item.classList.toggle('et-perso-ouverte', !!o);
    b.setAttribute('aria-expanded', o ? 'true' : 'false');
    b.querySelector('span').textContent = o ? texte('masquer-perso', 'Masquer la personnalisation') : texte('voir-perso', 'Voir la personnalisation');
  }
  function repli(item) {
    var props = Array.prototype.filter.call(item.querySelectorAll('dl .product-option.et-prop'), function (o) { return !o.classList.contains('et-cache'); });
    var dl = item.querySelector('dl');
    if (!props.length || !dl) return;
    var v = item.querySelector('.quantity__input');
    var rangee = document.createElement('div');
    rangee.className = 'et-perso-actions';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'et-perso-btn';
    b.setAttribute('data-cle', (v ? v.getAttribute('data-quantity-variant-id') : '') + '|' + props.map(function (o) { return o.textContent.trim(); }).join('|'));
    b.innerHTML = '<span></span><svg class="et-perso-btn__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    rangee.appendChild(b);
    // « Modifier » : ouvre « Éditer les options » d'APO sur la page panier (panier-refonte.js, ?modifier=<id APO>)
    var id = item.getAttribute('data-et-mws');
    var panier = document.querySelector('cart-drawer.elite-tiroir .et-pied__panier');
    if (id && /^\d+$/.test(id) && panier) {
      var a = document.createElement('a');
      a.className = 'et-perso-modif';
      a.href = panier.getAttribute('href') + '?modifier=' + id;
      a.setAttribute('data-et-modifier', id);
      a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16z"/></svg><span></span>';
      a.querySelector('span').textContent = texte('modifier', 'Modifier');
      rangee.appendChild(a);
    }
    dl.insertAdjacentElement('afterend', rangee);
    regler(item, b, persoOuvertes[b.getAttribute('data-cle')]);
  }
  // déjà sur la page panier : on ferme le tiroir et on ouvre la fenêtre d'APO de la ligne, sans recharger
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('cart-drawer.elite-tiroir [data-et-modifier], cart-drawer.elite-tiroir [data-et-personnaliser]');
    if (!a || !pagePanier) return;
    var m = a.getAttribute('data-et-modifier'), p = a.getAttribute('data-et-personnaliser');
    if (m && typeof window.pnOuvrirEdition !== 'function') return;
    if (p && typeof window.pnPersonnaliser !== 'function') return;
    e.preventDefault();
    var d = tiroir();
    if (d && typeof d.close === 'function') d.close();
    if (m) window.pnOuvrirEdition(m);
    else window.pnPersonnaliser(p.split('.')[0], p.split('.')[1]);
  });

  /* ── Personnaliser une ligne sans flocage (demande du user, 21/10/2026 : « pour les upsells, une fois ajouté,
     propose la personnalisation ») ──
     Seulement si le produit a des options APO (adresse publique d'APO : 200 = options, 204 = aucune ; mis en cache).
     Ligne venue de la fiche produit (identifiant APO présent) → /cart?modifier=<id> modifie la ligne ; ligne ajoutée
     depuis les suggestions (sans identifiant) → /cart?personnaliser=<produit>.<variante> : panier-refonte.js ouvre la
     fenêtre d'APO puis remplace la ligne d'origine par la ligne floquée. Les lignes ajoutées depuis les suggestions
     ont une invitation plus visible. */
  var optionsApo = lire('etOptionsApo') || {};
  function aDesOptions(produit, variante) {
    if (Object.prototype.hasOwnProperty.call(optionsApo, produit)) return Promise.resolve(optionsApo[produit]);
    var cfg = window.mwApoInit;
    if (!cfg || !cfg.shop_domain || cfg.cache_hash == null) return Promise.resolve(false);
    var url = 'https://apo-admin.mageworx.com/front/product/' + cfg.shop_domain + '/' + cfg.cache_hash + '/' + produit + '/' + variante + '.js';
    return fetch(url, { credentials: 'omit' })
      .then(function (r) {
        optionsApo[produit] = r.status === 200;
        ecrire('etOptionsApo', optionsApo);
        return optionsApo[produit];
      })
      .catch(function () { return false; });
  }
  function lienPersonnaliser(produit, variante, idLigne) {
    var panier = document.querySelector('cart-drawer.elite-tiroir .et-pied__panier');
    var base = panier ? panier.getAttribute('href') : RACINE + 'cart';
    var a = document.createElement('a');
    if (idLigne) { a.href = base + '?modifier=' + idLigne; a.setAttribute('data-et-modifier', idLigne); }
    else { a.href = base + '?personnaliser=' + produit + '.' + variante; a.setAttribute('data-et-personnaliser', produit + '.' + variante); }
    return a;
  }
  function invitationPerso(item) {
    if (item.querySelector('dl .product-option.et-prop:not(.et-cache)')) return; // déjà personnalisé
    var produit = item.getAttribute('data-et-produit');
    var v = item.querySelector('.quantity__input');
    var variante = v && v.getAttribute('data-quantity-variant-id');
    if (!/^\d+$/.test(produit || '') || !/^\d+$/.test(variante || '')) return;
    var idLigne = item.getAttribute('data-et-mws');
    if (!/^\d+$/.test(idLigne || '')) idLigne = '';
    aDesOptions(produit, variante).then(function (ok) {
      if (!ok || !item.isConnected || item.querySelector('.et-perso-invite, .et-perso-actions')) return;
      var details = item.querySelector('.cart-item__details');
      if (!details) return;
      var a = lienPersonnaliser(produit, variante, idLigne);
      var suggeree = (lire('etUpsells') || []).indexOf(variante) > -1;
      if (suggeree) {
        var box = document.createElement('div');
        box.className = 'et-perso-invite';
        box.innerHTML = '<span class="et-perso-invite__txt"><strong></strong><span></span></span>';
        box.querySelector('strong').textContent = texte('invite', 'Personnalisez-le');
        box.querySelector('.et-perso-invite__txt > span').textContent = texte('invite-detail', 'Nom, numéro, patchs');
        a.className = 'et-perso-invite__btn';
        a.textContent = texte('personnaliser', 'Personnaliser');
        box.appendChild(a);
        details.appendChild(box);
      } else {
        var rangee = document.createElement('div');
        rangee.className = 'et-perso-actions';
        a.className = 'et-perso-modif';
        a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16z"/></svg><span></span>';
        a.querySelector('span').textContent = texte('personnaliser', 'Personnaliser');
        rangee.appendChild(a);
        details.appendChild(rangee);
      }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer.elite-tiroir .et-perso-btn');
    if (!b) return;
    var item = b.closest('.cart-drawer-item');
    var o = !item.classList.contains('et-perso-ouverte');
    persoOuvertes[b.getAttribute('data-cle')] = o;
    regler(item, b, o);
  });

  /* ── Suggestions ── */
  var cache = {};
  var dernierHtml = '';
  var enCours = null;
  function memo() {
    var m = lire(CLE_SUGG) || {};
    var t = Date.now();
    Object.keys(m).forEach(function (k) { if (!m[k] || t - m[k].t > DUREE_CACHE) delete m[k]; });
    return m;
  }
  function htmlDe(sig) {
    if (cache[sig]) return cache[sig];
    var m = memo()[sig];
    return m ? (cache[sig] = m.h) : '';
  }
  function retenir(sig, html) {
    cache[sig] = html;
    var m = memo();
    m[sig] = { h: html, t: Date.now() };
    var cles = Object.keys(m).sort(function (a, b) { return m[b].t - m[a].t; });
    cles.slice(3).forEach(function (k) { delete m[k]; });
    ecrire(CLE_SUGG, m);
  }
  function remplir(box, html, provisoire) {
    box.innerHTML = html;
    box.hidden = !box.querySelector('.et-carte');
    if (provisoire) {
      // en attendant les nouvelles suggestions : les anciennes, sans les produits qui viennent d'entrer au panier
      var d = tiroir();
      var dans = {};
      Array.prototype.forEach.call(d.querySelectorAll('.cart-drawer-item .quantity__input'), function (i) { dans[i.getAttribute('data-quantity-variant-id')] = true; });
      Array.prototype.forEach.call(box.querySelectorAll('.et-carte'), function (c) {
        var v = c.querySelector('[data-et-variante]');
        var opts = v && v.tagName === 'SELECT' ? Array.prototype.map.call(v.options, function (o) { return o.value; }) : [v && v.value];
        if (opts.some(function (id) { return dans[id]; })) c.remove();
      });
    } else box.setAttribute('data-et-pret', '');
    fleches(box);
  }

  /* ── Flèches de défilement des suggestions (ordinateur, demande du user le 21/10/2026) ──
     Posées par le JS (le HTML des suggestions est en cache dans le navigateur) ; masquées au bout de la rangée. */
  var FLECHE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  function fleches(box) {
    Array.prototype.forEach.call(box.querySelectorAll('.et-rail'), function (rail) {
      if (rail.parentNode.classList.contains('et-rail-cadre')) return;
      var cadre = document.createElement('div');
      cadre.className = 'et-rail-cadre';
      rail.parentNode.insertBefore(cadre, rail);
      cadre.appendChild(rail);
      [-1, 1].forEach(function (sens) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'et-fleche et-fleche--' + (sens < 0 ? 'g' : 'd');
        b.setAttribute('aria-label', sens < 0 ? '‹' : '›');
        b.setAttribute('data-et-sens', sens);
        b.innerHTML = FLECHE;
        cadre.appendChild(b);
      });
      majFleches(rail);
    });
  }
  function majFleches(rail) {
    var cadre = rail.parentNode;
    if (!cadre || !cadre.classList.contains('et-rail-cadre')) return;
    var max = rail.scrollWidth - rail.clientWidth;
    cadre.classList.toggle('et-debut', rail.scrollLeft <= 2);
    cadre.classList.toggle('et-fin', rail.scrollLeft >= max - 2);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer.elite-tiroir .et-fleche, .et-page .et-fleche');
    if (!b) return;
    var rail = b.parentNode.querySelector('.et-rail');
    var carte = rail.querySelector('.et-carte');
    var pas = carte ? (carte.getBoundingClientRect().width + 10) * 2 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: pas * parseInt(b.getAttribute('data-et-sens'), 10), behavior: reduit ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('et-rail')) majFleches(t);
  }, true);
  function suggestions(d) {
    var box = d.querySelector('.et-sugg');
    if (!box || box.hasAttribute('data-et-pret')) return;
    var sig = box.getAttribute('data-et-sig');
    var html = htmlDe(sig);
    if (html) { remplir(box, html); dernierHtml = html; return; }
    if (dernierHtml && !box.hasAttribute('data-et-provisoire')) {
      box.setAttribute('data-et-provisoire', '');
      remplir(box, dernierHtml, true);
    }
    if (ouvert()) charger();
  }
  function charger() {
    if (enCours) return enCours;
    var relancer = false;
    enCours = fetch(RACINE + '?sections=' + SECTION, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[SECTION] || '', 'text/html');
        var c = doc.querySelector('.et-sugg__contenu');
        if (!c) throw new Error('vide');
        var sig = c.getAttribute('data-et-sig');
        retenir(sig, c.innerHTML);
        dernierHtml = c.innerHTML;
        var d = tiroir();
        var box = d && d.querySelector('.et-sugg');
        if (!box || box.hasAttribute('data-et-pret')) return;
        if (box.getAttribute('data-et-sig') === sig) remplir(box, c.innerHTML);
        else relancer = true; // le panier a encore changé pendant le chargement
      })
      .catch(function () {
        var d = tiroir();
        var box = d && d.querySelector('.et-sugg:not([data-et-pret])');
        if (box && !box.querySelector('.et-carte')) box.hidden = true;
      })
      .then(function () {
        enCours = null;
        if (relancer) charger();
      });
    return enCours;
  }

  /* ── Ajout en un clic depuis une suggestion ── */
  var nouvelleVariante = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer.elite-tiroir [data-et-ajout], .et-page [data-et-ajout]');
    if (!b) return;
    e.preventDefault();
    var carte = b.closest('.et-carte');
    var champ = carte.querySelector('[data-et-variante]');
    var id = champ && parseInt(champ.value, 10);
    if (!id || b.classList.contains('is-chargement')) return;
    var err = carte.querySelector('.et-carte__erreur');
    if (err) err.remove();
    b.classList.add('is-chargement');
    fetch(RACINE + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.sections) throw res.j;
        b.classList.remove('is-chargement');
        b.classList.add('is-fait');
        nouvelleVariante = id;
        // variante ajoutée depuis une suggestion : invitation à la personnaliser sur sa ligne
        var ajoutees = lire('etUpsells') || [];
        if (ajoutees.indexOf(String(id)) < 0) ajoutees.push(String(id));
        ecrire('etUpsells', ajoutees.slice(-30));
        var produit = carte.getAttribute('data-et-produit');
        var d = tiroir();
        setTimeout(function () {
          // suggestion de la page panier : la page entière doit montrer la nouvelle ligne (et son bouton Personnaliser)
          if (carte.closest('.et-page')) { location.reload(); return; }
          if (d && typeof d.renderContents === 'function') d.renderContents(res.j, true);
          else location.reload();
          aDesOptions(produit, String(id)).then(function (ok) {
            annoncer(texte('ajoute', 'Ajouté au panier'), ok ? { produit: produit, variante: String(id) } : null);
          });
        }, 350);
      })
      .catch(function (j) {
        b.classList.remove('is-chargement');
        var p = document.createElement('p');
        p.className = 'et-carte__erreur';
        p.setAttribute('role', 'alert');
        p.textContent = (j && (j.description || j.message)) || texte('erreur', 'Impossible d’ajouter cet article');
        carte.appendChild(p);
        setTimeout(function () { p.remove(); }, 4000);
      });
  });
  // ligne ajoutée (suggestion, ou fiche produit tiroir fermé) : surlignée un instant ; pas pour un + / − dans le tiroir
  function marquerNouvelle(d, initial) {
    var q = {};
    Array.prototype.forEach.call(d.querySelectorAll('.cart-drawer-item .quantity__input'), function (i) {
      var v = i.getAttribute('data-quantity-variant-id');
      q[v] = (q[v] || 0) + (parseInt(i.value, 10) || 0);
    });
    var avant = etat.q;
    etat.q = q;
    if (initial || !avant || (!nouvelleVariante && ouvert())) return;
    nouvelleVariante = null;
    Object.keys(q).forEach(function (v) {
      if (q[v] <= (avant[v] || 0)) return;
      var i = d.querySelector('.cart-drawer-item .quantity__input[data-quantity-variant-id="' + v + '"]');
      var li = i && i.closest('.cart-drawer-item');
      if (li) li.classList.add('et-nouveau');
    });
  }
  var toast = null, toastMinuteur = null;
  // action : { produit, variante } → bouton « Personnaliser » dans le message (article ajouté depuis une suggestion)
  function annoncer(msg, action) {
    var d = tiroir();
    if (!d) return;
    if (!toast || !toast.isConnected) {
      toast = document.createElement('div');
      toast.className = 'et-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span>';
      d.appendChild(toast);
    }
    var ancienne = toast.querySelector('.et-toast__action');
    if (ancienne) ancienne.remove();
    toast.classList.toggle('is-action', !!action);
    if (action) {
      var a = lienPersonnaliser(action.produit, action.variante, '');
      a.className = 'et-toast__action';
      a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16z"/></svg><span></span>';
      a.querySelector('span').textContent = texte('personnaliser', 'Personnaliser');
      toast.appendChild(a);
    }
    var panneau = d.querySelector('.drawer__inner');
    var pied = d.querySelector('.drawer__footer');
    var rp = panneau ? panneau.getBoundingClientRect() : { left: 0, width: window.innerWidth };
    var bas = pied ? window.innerHeight - pied.getBoundingClientRect().top + 14 : 24;
    toast.style.left = (rp.left + rp.width / 2) + 'px';
    toast.style.bottom = bas + 'px';
    toast.querySelector('span').textContent = msg;
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toastMinuteur);
    toastMinuteur = setTimeout(function () { toast.classList.remove('is-visible'); }, action ? 6500 : 2200);
  }

  /* ── Photos « Patch perso » jusqu'à la commande (repris de Panier/panier-refonte.js, 13/10/2026) ──
     Au paiement, le cart transform d'APO ne garde que les attributs listés dans la propriété cachée __mws_apo_cta :
     chaque « Patch perso n » y est recopié, sans toucher au prix. */
  function numeroPropriete(k) {
    var r = /^patch perso(?: (\d+))?$/i.exec(String(k || '').trim());
    return r ? (r[1] ? parseInt(r[1], 10) : 1) : 0;
  }
  function ctaAvecPhotos(props) {
    var cta;
    try { cta = JSON.parse(props.__mws_apo_cta || 'null'); } catch (e) { return null; }
    if (!cta || !Array.isArray(cta.attributes)) return null;
    var avant = JSON.stringify(cta.attributes);
    var photos = Object.keys(props).filter(function (k) { return numeroPropriete(k) && props[k]; })
      .sort(function (a, b) { return numeroPropriete(a) - numeroPropriete(b); });
    cta.attributes = cta.attributes.filter(function (a) { return !numeroPropriete(a && a.key); })
      .concat(photos.map(function (k) { return { key: k, value: props[k] }; }));
    return JSON.stringify(cta.attributes) === avant ? null : JSON.stringify(cta);
  }
  var synchroPhotos = null;
  function photos(d) {
    if (pagePanier || synchroPhotos) return; // la page panier a déjà son correctif (panier-refonte.js)
    var aFaire = Array.prototype.some.call(d.querySelectorAll('.cart-drawer-item dl .product-option dt'), function (dt) {
      return numeroPropriete(dt.textContent.replace(/:\s*$/, ''));
    });
    if (!aFaire) return;
    synchroPhotos = fetch(RACINE + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).reduce(function (suite, it) {
          var cta = ctaAvecPhotos(it.properties || {});
          if (!cta) return suite;
          return suite.then(function () {
            var props = {};
            for (var k in it.properties) props[k] = it.properties[k];
            props.__mws_apo_cta = cta;
            return fetch(RACINE + 'cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () { synchroPhotos = null; });
  }
  // paiement demandé pendant la recopie : on attend qu'elle finisse
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer.elite-tiroir [name="checkout"]');
    if (!b) return;
    if (synchroPhotos) {
      e.preventDefault();
      e.stopPropagation();
      b.classList.add('is-chargement');
      synchroPhotos.then(function () { b.classList.remove('is-chargement'); b.click(); });
      return;
    }
    b.classList.add('is-chargement');
    setTimeout(function () { b.classList.remove('is-chargement'); }, 8000);
  }, true);

  /* ── Page panier : barre livraison, 3+1 et suggestions aussi sur /cart (demande du user, 21/10/2026) ──
     Section sections/elite-panier-page.liquid demandée à la volée et posée autour de la liste d'articles (hors de
     .js-contents, que le thème redessine) ; redemandée après chaque changement de quantité (cartQuantityUpdated). */
  var blocsEnCours = false, blocsARefaire = false;
  function blocsPagePanier() {
    if (!pagePanier) return;
    var liste = document.querySelector('cart-items form#cart');
    if (!liste) return;
    if (blocsEnCours) { blocsARefaire = true; return; }
    blocsEnCours = true;
    fetch(RACINE + '?sections=elite-panier-page', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['elite-panier-page'] || '', 'text/html');
        [['.et-page-haut', 'beforebegin'], ['.et-page-bas', 'afterend']].forEach(function (x) {
          var neuf = doc.querySelector(x[0]);
          var ancien = document.querySelector('cart-items ' + x[0]);
          if (neuf) {
            var rails = {};
            if (ancien) Array.prototype.forEach.call(ancien.querySelectorAll('.et-rail'), function (r, i) { rails[i] = r.scrollLeft; });
            if (ancien) ancien.replaceWith(neuf);
            else liste.insertAdjacentElement(x[1], neuf);
            var sugg = neuf.querySelector('.et-sugg');
            if (sugg) { sugg.hidden = !sugg.querySelector('.et-carte'); fleches(sugg); }
            Array.prototype.forEach.call(neuf.querySelectorAll('.et-rail'), function (r, i) { if (rails[i]) r.scrollLeft = rails[i]; majFleches(r); });
          } else if (ancien) ancien.remove();
        });
      })
      .catch(function () {})
      .then(function () {
        blocsEnCours = false;
        if (blocsARefaire) { blocsARefaire = false; blocsPagePanier(); }
      });
  }
  var minuteurBlocs = null;
  document.addEventListener('cartQuantityUpdated', function () {
    clearTimeout(minuteurBlocs);
    minuteurBlocs = setTimeout(blocsPagePanier, 300);
  });

  /* ── Branchement ── */
  function traiter(initial) {
    var d = tiroir();
    if (!d) return;
    livraison(d, initial);
    promo(d, initial);
    lignes(d);
    marquerNouvelle(d, initial);
    suggestions(d);
    photos(d);
    garderEtat();
  }
  var planifie = false;
  function planifier() {
    if (planifie) return;
    planifie = true;
    // micro-tâche : traité avant l'affichage, la barre ne saute pas à sa valeur finale
    Promise.resolve().then(function () { planifie = false; traiter(false); });
  }
  function aLOuverture() {
    var d = tiroir();
    var box = d && d.querySelector('.et-sugg:not([data-et-pret])');
    if (box) charger();
    var f = fetesEnAttente.splice(0);
    f.forEach(function (x) { feter(x[0], x[1]); });
  }
  function brancher() {
    blocsPagePanier();
    var d = tiroir();
    if (!d) return;
    traiter(true);
    new MutationObserver(planifier).observe(d, { childList: true, subtree: true });
    var etaitOuvert = ouvert();
    new MutationObserver(function () {
      var o = ouvert();
      if (o && !etaitOuvert) aLOuverture();
      etaitOuvert = o;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    // préchargement au repos : le tiroir s'ouvre ensuite avec ses suggestions déjà prêtes
    var box = d.querySelector('.et-sugg:not([data-et-pret])');
    if (box) (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () { charger(); }, { timeout: 4000 });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
